import React from 'react';
import s from './MovieSentimentCountCinemaDetails.module.scss';
import { getSentimentCount } from '../../services/sentimentServices';
import cx from 'classnames';

const MovieSentimentCountCinemaDetails = (props: { metricInfo?: {} | undefined }) => {
	const { metricInfo = {} } = props;
	const sentimentCountData = getSentimentCount({ metricData: metricInfo }, false);
	const { likePercent } = sentimentCountData;

	return (
		<>
			{!!likePercent && (
				<div className={s.ratingsWrap}>
					<i className={cx('redHeartSolid', s.heartFill)} />
					<span>{likePercent}%</span>
				</div>
			)}
		</>
	);
};

export default MovieSentimentCountCinemaDetails;
